import { render, staticRenderFns } from "./zhuanhuo.vue?vue&type=template&id=86434498&scoped=true&"
import script from "./zhuanhuo.vue?vue&type=script&lang=js&"
export * from "./zhuanhuo.vue?vue&type=script&lang=js&"
import style0 from "./zhuanhuo.vue?vue&type=style&index=0&id=86434498&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86434498",
  null
  
)

export default component.exports